import { trigger } from '@angular/animations';
import { Component, HostBinding, ViewEncapsulation } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { fadeInOutOnEnterLeave } from './animations/fade-in-out-on-enter-leave';
import { selectDisplaySpinner } from './app.selectors';
import { AppState } from './app.state';

/**
 * This class is the base class everything gets rendered off of.
 */
@Component({
	selector: 'ahp-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
	encapsulation: ViewEncapsulation.None,
	animations: [trigger('fadeInAndOut', fadeInOutOnEnterLeave)],
})
export class AppComponent {
	/**
	 * Bind out class to the main element.
	 */
	@HostBinding('class') hostClasses = 'ap-app';
	/**
	 * If we should display the full-page spinner.
	 */
	displaySpinner$: Observable<boolean>;

	constructor(private store: Store<AppState>) {}

	afterViewInit() {
		this.displaySpinner$ = this.store.select(selectDisplaySpinner);
	}
}
